import { AlpineComponent } from '@alpinejs/csp';

const AuthorStage = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'author-stage--visible' : '';
  }
});

export default AuthorStage;
